module.exports = __webpack_public_path__ + "static/img/2.f3f9650.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/7/1/eng/2.png
// module id = 6ym4
// module chunks = 0